// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './utils/rem.js'
import './utils/variable.js'
import * as utils from './utils/http.js'
import { Toast, MessageBox, Picker, Popup, Indicator, Radio, Field, Button,
  Navbar, TabItem, DatetimePicker, Swipe, SwipeItem } from 'mint-ui'
import H5Header from './components/header/h5-header'
import VConsole from 'vconsole'
import './plugins/element-ui.js'

Vue.prototype.$updateToken = utils.updateToken
Vue.prototype.$get = utils.get
Vue.prototype.$post = utils.post
Vue.prototype.$message = MessageBox
Vue.prototype.$toast = Toast
Vue.prototype.$loading = Indicator
Vue.component(Picker.name, Picker)
Vue.component(Popup.name, Popup)
Vue.component(Radio.name, Radio)
Vue.component(Field.name, Field)
Vue.component(Button.name, Button)

Vue.component(Navbar.name, Navbar)
Vue.component(TabItem.name, TabItem)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)

Vue.component(H5Header.name, H5Header)
if (location.href.match('test|192.168') !== null) {
  // eslint-disable-next-line no-new
  new VConsole()
  // var theHead = document.getElementsByTagName('head').item(0)
  // // 创建脚本的dom对象实例
  // var myScript = document.createElement('script')
  // myScript.src = '//cdn.jsdelivr.net/npm/eruda' // 指定脚本路径
  // myScript.type = 'text/javascript' // 指定脚本类型
  // myScript.defer = true // 程序下载完后再解析和执行
  // theHead.appendChild(myScript) // 把dom挂载到头部
  // myScript.onload = function () {
  //   eruda.init()
  // }
}
Vue.config.productionTip = false
// 全局挂载属性
Vue.prototype.$imgHost = `${location.protocol}//image.daishupei.com`
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js